import { t } from 'common-translation/tools';

export const Meta = {
  get DEFAULT_TITLE() {
    return 'Tencent Cloud';
  },

  get DEFAULT_KEYWORDS() {
    return t('Tencent Cloud,Cloud Virtual Machine,virtual machine,CDN,Cloud Object Service,Cloud Block Storage,Cloud database,Internet plus solution,Tencent Cloud');
  },

  get DEFAULT_DESCRIPTION() {
    return t('Tencent Cloud is a secure, reliable and high-performance cloud compute service provided by Tencent. Tencent is now the largest Internet company in China, even in Asia, which provides services for millions of people via its flagship products like QQ and WeChat.');
  },
};
